/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';

// actions
import { updatePageDetails, changePage } from '@insticator/insticator-ui';

// actual presentational component that will utilize application state and actions (will be exported after being infused with state/actions)
import DataLastUpdated from 'material/callout/datalastupdated/datalastupdated';



/* ========== ~~~~~~~~~~ CALLOUT : DATA LAST UPDATED : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ sessionStatus, appStatus }) => ({
    sessionStatus,
    appStatus
});

// map actions
const mapDispatchToProps = dispatch => ({
	changePage: (location) => {
		dispatch(updatePageDetails(location))
    	dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(DataLastUpdated);
